import React from 'react';
import {
    Caption,
    pxToRem,
    useDeviceTypeContext,
    useStyles,
} from '@archipro-design/aria';
import * as S from './CurrentLocation.style';
import { CustomLocation } from '@archipro-design/icons';
import { getCoordinatesByBrowser } from '@modules/location/hook/use-current-coordinates';
import useClosestLocality from '../../hook/use-closest-locality';
import type { Locality } from '../../type/locality';
import { useLatest } from 'ahooks';

interface Props {
    onLocate?: (locality: Locality) => void;
}

const CurrentLocation = ({ onLocate }: Props) => {
    const { css } = useStyles();
    const [error, setError] = React.useState(false);
    const onLocateRef = useLatest(onLocate);
    const { mobile } = useDeviceTypeContext();

    const { search, locality } = useClosestLocality();

    const onClick = () => {
        getCoordinatesByBrowser()
            .then((coord) => {
                if (coord) {
                    search(coord);
                }
            })
            .catch(() => {
                setError(true);
            });
    };

    React.useEffect(() => {
        if (locality) {
            onLocateRef.current?.(locality);
        }
    }, [locality, onLocateRef]);

    return (
        <div className={css(S.CurrentLocation)}>
            <Caption variant="03" onClick={onClick} link={!mobile}>
                <CustomLocation
                    variables={{
                        '1xSize': pxToRem(16),
                    }}
                />
                Use my current location
            </Caption>
            {error && (
                <Caption variant="04" className={css(S.ErrorMessage)}>
                    Please change your browser settings to allow location
                    services.
                </Caption>
            )}
        </div>
    );
};
export default CurrentLocation;
